<template>
  <div class="p-home-page">
    <div class="p-page-wrapper">
      <header class="p-home-page__header">
        <router-link :to="{ name: 'home' }" class="p-logo-2"></router-link>

        <v-spacer></v-spacer>

        <p-locale-switcher class="mr-10"></p-locale-switcher>

        <div v-if="!isAuthenticated">
          <v-btn
            :to="{ name: 'projects' }"
            color="primary"
            class="p-btn-text mr-6"
            text
          >
            {{ $t('login') }}
          </v-btn>
        </div>

        <p-user-avatar-menu v-else-if="currentUser"></p-user-avatar-menu>

        <div v-else>
          <v-btn
            @click="logout"
            color="primary"
            class="p-btn-text mr-6"
            text
          >
            {{ $t('logout') }}
          </v-btn>
        </div>
      </header>

      <div class="text-center mt-10">
        <h1 class="p-font-harabara text-lowercase">{{ $t('appName') }}</h1>
        <p
          v-html="$t('home.description')"
        ></p>
        <v-btn
          v-if="!isAuthenticated"
          :to="{ name: 'projects' }"
          color="primary"
          class="p-btn-rounded mt-2"
          large
          rounded
          dark
        >
          {{ $t('login') }}
        </v-btn>
        <v-btn
          v-else
          :to="{ name: 'projects' }"
          color="primary"
          class="p-btn-rounded mt-2"
          large
          rounded
          dark
        >
          {{ $t('home.dashboard') }}
        </v-btn>
        <img
          :src="require('@/assets/images/home.png')"
          class="d-block mx-auto mt-16"
          alt="home image"
        />
      </div>

      <div class="p-home-page__contact-form">
        <v-form ref="form" @submit.stop.prevent>
          <h2 class="p-font-harabara text-lowercase">{{ $t('home.contactForm.title') }}</h2>
          <p v-html="$t('home.contactForm.description')" class="mb-10"></p>

          <label>{{ $t('home.contactForm.name') }}</label>
          <v-text-field
            v-model="contact.name"
            :rules="rules.name"
            tabindex="1"
            clearable
            solo
            flat
          ></v-text-field>

          <label>{{ $t('home.contactForm.email') }}</label>
          <v-text-field
            type="email"
            v-model="contact.email"
            :rules="rules.email"
            tabindex="1"
            clearable
            validate-on-blur
            solo
            flat
          ></v-text-field>

          <label>{{ $t('home.contactForm.message') }}</label>
          <v-textarea
            v-model="contact.message"
            :rules="rules.message"
            tabindex="1"
            solo
            flat
          ></v-textarea>

          <v-btn
            :loading="sending"
            color="primary"
            class="p-btn-rounded mt-4"
            tabindex="1"
            large
            rounded
            dark
            @click="submit"
          >
            {{ $t('home.contactForm.send') }}
          </v-btn>
        </v-form>
      </div>

      <div class="p-home-page__copyright">
        {{ $t('copyright', { year: currentYear }) }}
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from 'vuex'

import contactUsApi from '@/api/contactUs.api'

import PUserAvatarMenu from '@/components/PUserAvatarMenu'
import PLocaleSwitcher from '@/components/PLocaleSwitcher'

import snackbarMixin from '@/mixins/snackbar.mixin'
import validationMixin from '@/mixins/validation.mixin'
import authMixin from '@/mixins/auth.mixin'


export default {
  components: {
    PUserAvatarMenu,
    PLocaleSwitcher
  },


  mixins: [
    snackbarMixin,
    validationMixin,
    authMixin
  ],


  data () {
    return {
      contact: {
        name: '',
        email: '',
        message: ''
      },
      sending: false
    }
  },


  computed: {
    ...mapGetters('user', ['currentUserId', 'currentUser']),

    currentYear () {
      return (new Date()).getFullYear()
    },

    rulesToApply () {
      const rule = this.rule

      return {
        name: [
          rule.required()
        ],
        email: [
          rule.required(),
          rule.email()
        ],
        message: [
          rule.required()
        ]
      }
    }
  },


  methods: {
    async submit () {
      const valid = await this.validate(this.rulesToApply)
      if (!valid) return

      try {
        this.sending = true
        await contactUsApi.sendMessage(this.contact)
        this.showSnackbarSuccess(this.$t('home.contactForm.messageSent'))
        this.$refs.form.reset()
      } catch (error) {
        this.showSnackbarError()
        this.$log.error(error)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>
